export default __webpack_public_path__ + "static/media/landscape2-MASK-zahner1.a8ff98c6.png";